var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.795 1.007a1.112 1.112 0 0 1 1.587 0 1.12 1.12 0 0 1 0 1.571l-8.047 8.047h20.554A1.106 1.106 0 0 1 26 11.737c0 .619-.492 1.127-1.111 1.127H4.335l8.047 8.032c.429.444.429 1.159 0 1.587a1.112 1.112 0 0 1-1.587 0L.843 12.531a1.093 1.093 0 0 1 0-1.571l9.952-9.953z",
  fillRule: "nonzero"
})));
export default SvgArrowLeft;